module.exports = __webpack_public_path__ + "img/modelMarket2.77514db3.png";